export default __webpack_public_path__ + "static/leonardo-logo-0eb5c6ae8d615386fa79c53244760f7e.jpg";